import { apiRequest } from './client.ts';

/**
 * Un partido con MI pronóstico al lado, tal como lo devuelve el backend.
 *
 * `is_open` y `counts_for_league` los calcula PostgreSQL con su propio reloj y con el
 * `joined_at` del miembro. No se recalculan aquí: son la respuesta del servidor, no una
 * pista que el cliente pueda mejorar.
 */
export interface LeagueMatch {
  match_id: number;
  kickoff_time: string;
  status: string;
  round_code: string | null;
  is_knockout: boolean;
  home_team: string;
  away_team: string;
  predicted_home_score: number | null;
  predicted_away_score: number | null;
  predicted_at: string | null;
  actual_home_score: number | null;
  actual_away_score: number | null;
  /** LA AUTORIDAD del plazo. Lo decide `matches_predictions_open(...)` en la base. */
  is_open: boolean;
  /**
   * LA AUTORIDAD sobre si se ven los pronósticos ajenos. **No es `!is_open`**: un
   * partido aplazado está cerrado (R9) y aun así no revela nada, porque su plazo se
   * reabrirá con la fecha nueva. Ver `matches_predictions_visible` (migración 0011).
   */
  predictions_visible: boolean;
  /** R15: si el partido es anterior a la entrada del miembro, esta liga no lo suma. */
  counts_for_league: boolean;
}

export interface MemberPrediction {
  user_id: string;
  username: string;
  predicted_home_score: number | null;
  predicted_away_score: number | null;
  counts_for_league: boolean;
}

export interface MyPredictionsResponse {
  /** Mi racha viva (R5/R19), calculada por el motor. 0 si está rota. */
  current_streak: number;
  /** Umbrales de R4, los mismos que activan los multiplicadores. */
  streak_thresholds: number[];
  matches: LeagueMatch[];
}

export function listMyPredictions(leagueId: string): Promise<MyPredictionsResponse> {
  return apiRequest(`/leagues/${leagueId}/predictions/me`);
}

export function submitPrediction(
  matchId: number,
  homeScore: number,
  awayScore: number,
): Promise<{ prediction: { match_id: number }; created: boolean }> {
  return apiRequest(`/matches/${matchId}/prediction`, {
    method: 'PUT',
    body: { home_score: homeScore, away_score: awayScore },
  });
}

/**
 * Pronósticos del resto de la liga para un partido.
 *
 * ⚠️ Antes del kickoff responde 409 `predictions_hidden_until_kickoff` y NO devuelve
 * nada, ni siquiera cuántos hay. La pantalla solo debe llamarla cuando el servidor ya
 * ha dicho que el partido empezó.
 */
export function listMatchPredictions(
  leagueId: string,
  matchId: number,
): Promise<{ match_id: number; kickoff_time: string; predictions: MemberPrediction[] }> {
  return apiRequest(`/leagues/${leagueId}/matches/${matchId}/predictions`);
}
